import { Card } from "./ui/card";
import { Lock } from "lucide-react";
import { useInternalNotes } from "./internal-notes/useInternalNotes";
import { NotesSection, AttachmentsSection, PreviewDialog } from "./internal-notes/sections";

export const InternalNotes = ({ requestId }) => {
  const n = useInternalNotes(requestId);
  return (
    <Card className="p-5 border-amber-200 bg-amber-50/40 mt-4" data-testid="internal-panel">
      <div className="flex items-center gap-2 mb-4">
        <Lock className="h-4 w-4 text-amber-600" />
        <h3 className="font-semibold text-slate-800 text-sm font-heading">Note Interne & Allegati</h3>
        <span className="text-[11px] text-amber-700 bg-amber-100 rounded-full px-2 py-0.5 ml-1">Solo Centrale Operativa</span>
      </div>
      <NotesSection notes={n.data.notes} loading={n.loading} saving={n.saving} onAdd={n.addNote} onDelete={n.delNote} />
      <AttachmentsSection attachments={n.data.attachments} uploading={n.uploading} previewLoading={n.previewLoading}
        onUpload={n.upload} onPreview={n.openPreview} onDownload={n.download} onDelete={n.delAtt} />
      <PreviewDialog preview={n.preview} onClose={n.closePreview} />
    </Card>
  );
};
